// eslint-disable-next-line import/prefer-default-export

export const CALENDAR_STATUS = {
  REVOKED: 'REVOKED',
  CONNECTED: 'CONNECTED',
};

export const REVOKE_CALENDAR_WARNING =
  'Access to your Google Calendar has been revoked. Events won’t sync until you reconnect your Calendar in the Integrations page.';

export const REVOKE_GOOGLE_WARNING =
  'Access to your Google Account has been revoked. Email And Events won’t sync until you reconnect your Google Accounts in the Integrations page.';

export const REQUIRED_GRANT_EMAIL_ERROR =
  'Permission granted is not sufficient, please reconnect your email with all required access.';

export const REQUIRED_GRANT_CALENDAR_ERROR =
  'Permission granted is not sufficient, please reconnect your calendar with all required access.';

export const handledErrors = ['popup_closed_by_user', 'access_denied'];

export const CALENDAR_MEETING_TYPE_MAPPING = {
  'Google Meet': 'Google Meet Meeting',
  teamsForBusiness: 'Teams For Business',
};
